export function formatCNPJ(value) {
  if (value) {
    const cnpj = value.toUpperCase().replace(/[^A-Z0-9]/g, '');

    return cnpj.replace(/([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{2})/g, '$1.$2.$3/$4-$5');
  }
  return value;
}
